"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniqueDriverValidation = void 0;
const InteractionHelper_1 = require("../helpers/InteractionHelper");
const FalconValidationMethodBase_1 = require("./FalconValidationMethodBase");
/**
 * Validates that driver (driverIndex) has no duplicates among all drivers
 */
class UniqueDriverValidation extends FalconValidationMethodBase_1.FalconValidationMethodBase {
    constructor(props, commandsExecutor) {
        super(commandsExecutor);
        this.POLICY_HOLDER_DRIVER_INDEX = "policyHolder";
        this.getDriverToValidate = (interaction) => {
            if (this.props.driverIndex === this.POLICY_HOLDER_DRIVER_INDEX) {
                return interaction === null || interaction === void 0 ? void 0 : interaction.policyHolder;
            }
            return interaction === null || interaction === void 0 ? void 0 : interaction.additionalDrivers[this.props.driverIndex];
        };
        this.props = props;
        if (this.props.driverIndex === undefined || this.props.driverIndex === null) {
            throw new Error("Missing setting: 'driverIndex'");
        }
    }
    validateInput(_input, context) {
        const interaction = this.getInteraction(context);
        if (!interaction) {
            return this.validResult();
        }
        const driverToValidate = this.getDriverToValidate(interaction);
        if (!driverToValidate.firstName ||
            !driverToValidate.lastName ||
            !driverToValidate.dateOfBirth) {
            return this.validResult();
        }
        const allDrivers = InteractionHelper_1.InteractionHelper.getAllDrivers(interaction);
        const duplicatesOfDriverToValidate = allDrivers.filter((driver) => InteractionHelper_1.InteractionHelper.driversEqual(driver, driverToValidate));
        if (duplicatesOfDriverToValidate.length > 1) {
            return this.invalidResult(this.getErrorMessage(context, "This driver has a duplicate"));
        }
        return this.validResult();
    }
}
exports.UniqueDriverValidation = UniqueDriverValidation;
//# sourceMappingURL=UniqueDriverValidation.js.map